import { IReactiveModel, RecognitionManager, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';

import { MicrofrontendViewModel } from '@/shared/presentation/Microfrontend.vm';

@ViewModel()
export class LayoutViewModel implements IReactiveModel {
  private navigate: NavigateFunction;

  constructor(
    private microfrontendViewModel: MicrofrontendViewModel,
    private recognitionManager: RecognitionManager,
  ) {
    makeAutoObservable(this);
  }

  @action
  async onInit({ navigate }) {
    this.navigate = navigate;
  }

  async logout() {
    this.recognitionManager.clearCredentials();
    this.microfrontendViewModel.clearAccount();
    this.navigate('/signin');
  }
}
